import React from "react";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import {
  Grid,
  Table,
  TableHeaderRow,
} from "@devexpress/dx-react-grid-material-ui";

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word",
  },
};

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
);

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0,
    }}
    {...restProps}
  />
);

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class StatusTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Status LED" },
        { name: "descriptionColumn", title: "Description" },
      ],
      rows: [
        {
          actionColumn: "Red flashes slowly",
          descriptionColumn: "Normal operation.",
        },
        {
          actionColumn: "Red flashes fast",
          descriptionColumn: "Firmware update in progress.",
        },
        {
          actionColumn: "Red is deactivated",
          descriptionColumn:
            "LED has been deactivated via the WebUI or the camera has no power.",
        },
        {
          actionColumn: "With HomeKit activated",
          descriptionColumn:
            "Behavior (lights up/flashes) according to Apple specifications. If the camera is integrated into Apple Home, the Home app controls the LEDs. To switch them off there, please deactivate them in the Home app.",
        },
        {
          actionColumn: "Blue permanently active",
          descriptionColumn: "WLAN connected / WPS ready (reset 3 - 14 s).",
        },
        {
          actionColumn: "Blue flashes slowly",
          descriptionColumn:
            "WPS active (2 min) / Reset 15 - 19 s → WLAN & IP config. remains active.",
        },
        {
          actionColumn: "Blue flashes fast",
          descriptionColumn:
            "WLAN interrupted / reset 20 - 29 s → Complete factory reset.",
        },
        {
          actionColumn: "Blue is deactivated",
          descriptionColumn:
            "LED off, no power or LAN operation / reset ≥ 30 s → old firmware partition.",
        },
        {
          actionColumn: "With HomeKit activated",
          descriptionColumn:
            "Behavior (lights up/flashes) according to Apple specifications. If the camera is integrated into Apple Home, the Home app controls the LEDs. To switch them off there, please deactivate them in the Home app.",
        },
      ],
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{ display: "inline-block", maxWidth: "915px" }}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

StatusTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StatusTable);
